// extracted by mini-css-extract-plugin
module.exports = {"root":"MultiTilePromo_root__UqgkO","promosContainer":"MultiTilePromo_promosContainer__jv5Kw"};